<script lang="ts">
	type Card = {
		name: string
		email: string
		phone?: string
	}

	export let card: Card
	export let cls = ''
</script>

<div class="styled-box {cls}">
	<img src="/images/icons/icon-person.svg" width="40px" alt="Info" />
	<p class="!mt-0 mb-0 text-lg">{card.name}</p>
	<a href="mailto:{card.email}" class="text mb-1 mt-1 block text-lg text-red-600">{card.email}</a>
	{#if card.phone}
		<a href="tel:{card.phone}" class="text-red-600">{card.phone}</a>
	{/if}
</div>

<style lang="scss">
	.styled-box {
		position: relative;
		padding: 20px;
		padding-left: 80px;
		box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.175);
		img {
			position: absolute;
			left: 20px;
			top: 50%;
			transform: translateY(-50%);
		}
	}
</style>
